import React, { useRef, useState } from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

import Buttonbar from "./Customfields/Components/Buttonbar";
import Overzicht from "./Customfields/Components/Overzicht";

//Form
import Text from "./Customfields/InputForms/Text";
import Email from "./Customfields/InputForms/Email";
import Select from "./Customfields/InputForms/Select";
import Coupon from "./Customfields/InputForms/Coupon";
import Mobilenr from "./Customfields/InputForms/Mobilenr";
import Selectpreorderingdate from "./Customfields/InputForms/preOrderDate";
import SelectpreorderingdateDefault from "./Customfields/InputForms/preOrderDateDefault";
import Selectpreorderingtime from "./Customfields/InputForms/preOrderTime";
import { GridLegacy } from "@mui/material";
import { useController } from "react-hook-form";
import FormJson from "../../../components/Forms/FormJson";
import PreOrderTimeDefault from "./Customfields/InputForms/preOrderTimeDefault";

function Customfields(props) {
  const [showInputForm, setShowInputForm] = useState(false);

  const form = useRef(null);

  const {
    field: { value: customFieldsValue, onChange: customFieldsOnChange },
  } = useController({ name: "customFields" });

  const handleButtonClick = (type) => {
    form.current = getInputForm(type);
    if (form.current) {
      setShowInputForm(true);
    }
  };

  const handleCloseClick = () => {
    form.current = null;
    setShowInputForm(false);
  };

  const handleEdit = (row) => {
    form.current = getInputForm(row.type, row);
    if (form.current) {
      setShowInputForm(true);
    }
  };

  const onDelete = (objectToDelete) => {
    customFieldsOnChange(
      JSON.stringify(JSON.parse(customFieldsValue).filter((obj) => obj.name !== objectToDelete.name))
    );
  };

  const onSave = (value, _, action) => {
    const arr = customFieldsValue ? JSON.parse(customFieldsValue) : [];
    if (action === "ADD") {
      arr.push(value);
    } else if (action === "EDIT") {
      arr.forEach((obj, key) => {
        if (obj.name === value.oldName) {
          delete value.oldName;
          arr[key] = value;
        }
      });
    }
    customFieldsOnChange(JSON.stringify(arr));
  };

  const getInputForm = (type, value = undefined) => {
    let form = null;
    let action = "ADD";
    if (value !== undefined) {
      action = "EDIT";
    }

    switch (type) {
      case "selectpreorderingdate":
        form = (
          <Selectpreorderingdate
            closeForm={handleCloseClick}
            onSave={(value) => onSave(value, "customFields", action)}
            value={value}
            {...props}
          />
        );
        break;
      case "selectpreorderingdatedefault":
        form = (
          <SelectpreorderingdateDefault
            closeForm={handleCloseClick}
            onSave={(value) => onSave(value, "customFields", action)}
            value={value}
            {...props}
          />
        );
        break;
      case "selectpreorderingtime":
        form = (
          <Selectpreorderingtime
            closeForm={handleCloseClick}
            onSave={(value) => onSave(value, "customFields", action)}
            value={value}
            {...props}
          />
        );
        break;
      case "selectpreorderingtimedefault":
        form = (
          <PreOrderTimeDefault
            closeForm={handleCloseClick}
            onSave={(value) => onSave(value, "customFields", action)}
            value={value}
            {...props}
          />
        );
        break;
      case "text":
        form = (
          <Text
            closeForm={handleCloseClick}
            onSave={(value) => onSave(value, "customFields", action)}
            value={value}
            {...props}
          />
        );
        break;
      case "email":
        form = (
          <Email
            closeForm={handleCloseClick}
            onSave={(value) => onSave(value, "customFields", action)}
            value={value}
            {...props}
          />
        );
        break;
      case "coupon":
        form = (
          <Coupon
            closeForm={handleCloseClick}
            onSave={(value) => onSave(value, "customFields", action)}
            value={value}
            {...props}
          />
        );
        break;
      case "mobilenr":
        form = (
          <Mobilenr
            closeForm={handleCloseClick}
            onSave={(value) => onSave(value, "customFields", action)}
            value={value}
            {...props}
          />
        );
        break;
      case "select":
        form = (
          <Select
            closeForm={handleCloseClick}
            onSave={(value) => onSave(value, "customFields", action)}
            value={value}
            {...props}
          />
        );
        break;
    }

    return form;
  };

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, flexWrap: "wrap" }}>
          <GridLegacy item xs={12}>
            <h3>
              <TranslationWrapper
                tDefault={"Custom fields settings"}
                tKey={"vestigingen.form.customfields.headers.customfieldssettings"}
              />
            </h3>
          </GridLegacy>
          <GridLegacy container spacing={1}>
            <GridLegacy item xs={12}>
              <Buttonbar disableAll={showInputForm} onClick={handleButtonClick} />
            </GridLegacy>
          </GridLegacy>

          {form.current}

          <Overzicht
            customFields={customFieldsValue}
            disableAll={showInputForm}
            onDelete={onDelete}
            onEdit={handleEdit}
          />

          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"JSON"} tKey={"vestigingen.form.customfields.headers.json"} />
              </h3>
            </GridLegacy>
            <FormJson name={"customFields"} tDefault={"JSON"} tKey={"vestigingen.form.customfields.headers.json"} />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Customfields;
